import { DirectiveOptions } from 'vue'
import { UserModule } from '@/store/modules/user'

export const permission: DirectiveOptions = {
  inserted(el, binding) {
    const { value } = binding
    // @ts-ignore
    const codes = UserModule.accesses.map(item => parseInt(item.code))
    if (value) {
      const code = value
      const hasPermission = codes.includes(code)
      if (!hasPermission) {
        el.style.display = 'none'
      }
    } else {
      throw new Error('need code! Like v-permission="100"')
    }
  }
}
